'use strict';

import $ from 'jquery';

$(function () {

});
